import React from 'react';
import './ChallengeTabs.css';

function ChallengeTabs({ activeFilter, onFilterChange, counts }) {
  return (
    <div className="challenges-tabs">
      <button 
        className={`tab ${activeFilter === 'active' ? 'active' : ''}`}
        onClick={() => onFilterChange('active')}
      >
        Active
        {activeFilter !== 'active' && counts && counts.active > 0 && (
          <span className="tab-count">{counts.active}</span>
        )}
      </button>
      <button 
        className={`tab ${activeFilter === 'accepting' ? 'active' : ''}`}
        onClick={() => onFilterChange('accepting')}
      >
        Open to Join
        {activeFilter !== 'accepting' && counts && counts.accepting > 0 && (
          <span className="tab-count">{counts.accepting}</span>
        )}
      </button>
      <button 
        className={`tab ${activeFilter === 'completed' ? 'active' : ''}`}
        onClick={() => onFilterChange('completed')}
      >
        Completed
        {activeFilter !== 'completed' && counts && counts.completed > 0 && (
          <span className="tab-count">{counts.completed}</span>
        )}
      </button>
    </div>
  );
}

export default ChallengeTabs;

